import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { memoize } from '@bingads-webui-universal/primitive-utilities';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
import { CampaignOData } from '@bingads-webui-react/campaign-odata';
import { CampaignType, siteMapPropType } from '@bingads-webui-react/with-site-map';
import { filterMapItem, campaignTypeFilter } from './processor-helpers';

const allTypes = [CampaignType.All];
const emptyTypes = [CampaignType.None];

const filterMapItemBase = (siteMap, types, permissions) => {
  const filter = mapItem => _.reduce(
    types,
    (result, type) =>
      result || campaignTypeFilter(type, mapItem, permissions),
    false
  );

  return filterMapItem(siteMap, filter);
};

const getCampaignTypes = types =>
  _.map(types, type => _.result(CampaignType, type, CampaignType.None));

const filterMapItemCached = memoize(filterMapItemBase);
const getCampaignTypesCached = memoize(getCampaignTypes);

/**
 * Only for testing
 */
export const testRef = { current: undefined };

export function processCampaignType(Component) {
  const Wrapper = ({ siteMap, ...props }) => {
    const processor = types => (<Component
      {...props}
      siteMap={filterMapItemCached(siteMap, types, props.permissions)}
    />);

    return (
      <CampaignOData
        call={({ currentAccount }) => currentAccount['Default.CampaignTypes'].$makeCall()}
        escapeHatch={({ currentAccount }) => (currentAccount ? undefined : {})}
        fallback={processor(allTypes)}
        onError={() => processor(emptyTypes)}
        testRef={testRef}
      >
        {campaignTypes => processor(_.isEmpty(campaignTypes.value) ?
          emptyTypes :
          getCampaignTypesCached(campaignTypes.value))}
      </CampaignOData>
    );
  };

  Wrapper.propTypes = {
    siteMap: siteMapPropType.isRequired,
    permissions: PropTypes.objectOf(PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.objectOf(PropTypes.bool),
      PropTypes.number,
    ])).isRequired,
  };

  return withPermissions(Wrapper);
}
